import { useState } from "react";
import { Link2 } from "lucide-react";
import { copyPlain } from "@/lib/copy";

interface CopyLinkButtonProps {
  url: string;
  className?: string;
}

export function CopyLinkButton({ url, className }: CopyLinkButtonProps) {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setError(false);
    try {
      await copyPlain(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={
        className ??
        "inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] text-text-tertiary hover:text-text"
      }
      title="Copy link to this item"
    >
      <Link2 className="h-3 w-3" />
      {copied ? "Copied!" : error ? "Failed" : "Link"}
    </button>
  );
}
